// The icon a navigation item wears — in the top bar's menus, the phone
// drawer and on Home alike. `item.icon` is a key from utils/navIcons.js,
// 'zsd' (the dashboards mark), or 'custom' with an uploaded image.

import { NAV_ICON_MAP } from '@platform/app-shell/frontend/utils/navIcons';

// Distinct 4-tile grid mark for Zebra Simple Dashboards — deliberately NOT
// the chart emoji, so the ZSD product reads as its own thing (carried over
// from the old sidebar). Monochrome via currentColor.
const ZSD_ICON = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="tn-item-icon-svg">
    <rect x="3" y="3" width="8" height="8" rx="2" opacity="0.92" />
    <rect x="13" y="3" width="8" height="8" rx="2" opacity="0.55" />
    <rect x="3" y="13" width="8" height="8" rx="2" opacity="0.75" />
    <rect x="13" y="13" width="8" height="8" rx="2" opacity="0.40" />
  </svg>
);

export default function NavItemIcon({ item, fallback }) {
  if (item.icon === 'custom' && item.customIconUrl) {
    return <img src={item.customIconUrl} alt="" className="tn-item-icon-img" />;
  }
  if (item.icon === 'zsd') return ZSD_ICON;
  const emoji = (item.icon && NAV_ICON_MAP[item.icon]) || fallback;
  if (!emoji) return null;
  return <span className="tn-item-icon" aria-hidden="true">{emoji}</span>;
}
